/**
 * Item and section-label recipe for menus built straight on Radix `DropdownMenu` primitives
 * (checkbox / radio rows, submenus) rather than on the `@/ui/DropdownMenu` wrappers. Shared so
 * the view-bar menus and the session Review tab menus stay identical.
 */
export const menuItemClasses =
  'flex h-8 cursor-pointer items-center gap-2.5 rounded-lg px-2 text-xs text-fg-secondary outline-none transition-colors select-none data-highlighted:bg-white/6 data-highlighted:text-fg data-disabled:opacity-50';

export const menuLabelClasses =
  'flex h-6 items-center px-2 text-3xs font-semibold uppercase tracking-[0.06em] text-fg-tertiary';
